<template>
  <div class="admin-pagination">
    <div class="pagination-info">
      <span class="info-text">
        第 {{ currentPage }} / {{ totalPages }} 页，共 {{ total }} 条
      </span>
      <!-- 调试信息 -->
      <span class="debug-info" v-if="$route.query.debug" style="margin-left: 10px; font-size: 12px; color: #999;">
        (total={{ total }}, pageSize={{ pageSize }}, totalPages={{ totalPages }})
      </span>
      <select
        :value="pageSize"
        @change="$emit('update:pageSize', parseInt($event.target.value))"
        class="form-control page-size-select"
      >
        <option value="10">10条/页</option>
        <option value="20">20条/页</option>
        <option value="50">50条/页</option>
        <option value="100">100条/页</option>
      </select>
    </div>

    <div class="pagination-controls">
      <button
        @click="$emit('update:currentPage', 1)"
        :disabled="currentPage === 1"
        class="btn btn-secondary btn-sm"
      >
        首页
      </button>

      <button
        @click="$emit('update:currentPage', currentPage - 1)"
        :disabled="currentPage === 1"
        class="btn btn-secondary btn-sm"
      >
        上一页
      </button>

      <div class="page-numbers" v-if="totalPages > 1">
        <button
          v-for="page in visiblePages"
          :key="page"
          @click="$emit('update:currentPage', page)"
          :class="['btn', 'btn-sm', page === currentPage ? 'btn-primary' : 'btn-secondary']"
          :disabled="page === '...'"
        >
          {{ page }}
        </button>
      </div>

      <!-- 当只有一页时显示当前页 -->
      <div class="page-numbers" v-else>
        <button class="btn btn-primary btn-sm" disabled>
          1
        </button>
      </div>

      <button
        @click="$emit('update:currentPage', currentPage + 1)"
        :disabled="currentPage === totalPages || totalPages === 0"
        class="btn btn-secondary btn-sm"
      >
        下一页
      </button>

      <button
        @click="$emit('update:currentPage', totalPages)"
        :disabled="currentPage === totalPages || totalPages === 0"
        class="btn btn-secondary btn-sm"
      >
        末页
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminPagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  emits: ['update:currentPage', 'update:pageSize'],
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    },
    visiblePages() {
      const total = this.totalPages
      const current = this.currentPage
      const delta = 2

      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1)
      }

      const range = []
      const rangeWithDots = []

      for (let i = Math.max(2, current - delta); i <= Math.min(total - 1, current + delta); i++) {
        range.push(i)
      }

      if (current - delta > 2) {
        rangeWithDots.push(1, '...')
      } else {
        rangeWithDots.push(1)
      }

      rangeWithDots.push(...range)

      if (current + delta < total - 1) {
        rangeWithDots.push('...', total)
      } else {
        rangeWithDots.push(total)
      }

      return rangeWithDots.filter((item, index, arr) => item !== arr[index - 1])
    }
  }
}
</script>

<style scoped>
.admin-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--spacing-lg);
  padding: var(--spacing-lg) 0;
  border-top: 1px solid var(--border-color);
  flex-wrap: wrap;
  gap: var(--spacing-lg);
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.info-text {
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  white-space: nowrap;
}

.page-size-select {
  width: auto;
  min-width: 100px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex-wrap: wrap;
}

.page-numbers {
  display: flex;
  gap: var(--spacing-xs);
}

.page-numbers .btn {
  min-width: 36px;
  padding: var(--spacing-xs) var(--spacing-sm);
}

@media (max-width: 768px) {
  .admin-pagination {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination-info {
    justify-content: space-between;
  }

  .pagination-controls {
    justify-content: center;
  }

  .page-numbers {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>